import { render, staticRenderFns } from "./ContentCardBack.vue?vue&type=template&id=70c12f02&scoped=true"
import script from "./ContentCardBack.vue?vue&type=script&lang=js"
export * from "./ContentCardBack.vue?vue&type=script&lang=js"
import style0 from "./ContentCardBack.vue?vue&type=style&index=0&id=70c12f02&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70c12f02",
  null
  
)

export default component.exports